/**
 * API Utilities - Shared API configuration and helpers
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

// Configure axios to send cookies with every request
axios.defaults.withCredentials = true;

// Get auth headers (admin token kept for backwards compatibility during migration)
export const getAuthHeaders = () => {
  const adminToken = localStorage.getItem('admin_token');
  const headers = { 'Content-Type': 'application/json' };
  if (adminToken) headers['X-Admin-Token'] = adminToken;
  return headers;
};

// Get admin auth headers
export const getAdminAuthHeaders = () => ({
  'X-Admin-Token': localStorage.getItem('admin_token')
});

// Handle API errors consistently
export const handleApiError = (error) => {
  if (error.response?.data?.detail) {
    return error.response.data.detail;
  }
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  return 'Ocorreu um erro. Tente novamente.';
};

// Format currency in EUR
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
